// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__2TI7D","ThumbZoom":"ChapterPlayer_ThumbZoom__2hz8g"};